export default {
  record: {
    label: '录屏项目',
    describe:
      '在线完成游戏试玩及视频录制，通过简单的参数调整，快速获取大量游戏录制视频。',
    guide: '查看录屏操作指南',
    download: '下载Mindworks插件',
    newcreate: '新建项目',
    filter: {
      projectname: '项目名称',
      versionname: '版本名称',
      projectid: '项目ID',
      versionid: '版本ID',
      search: '搜索',
      projectstatus: '项目状态',
      uploaded: '已上传',
      waitingupload: '待上传',
      versionstatus: '版本状态',
      editing: '编辑中',
      exporting: '导出中',
      exported: '已导出',
      exportfailed: '导出失败',
      cancelled: '已取消',
    },
    table: {
      nameid: '项目/版本名称及ID',
      operation: {
        name: '操作',
        createtips: '创建版本',
        lockedtips: '录屏工程文件已锁定，点击可解锁。',
        locktips: '录屏工程文件已解锁，点击可锁定。',
        copytips: '复制',
        edit: '编辑',
        details: '查看详情',
        delete: '删除',
        exporthistory: '导出历史',
      },
      productname: '产品名称',
      parameters: '参数数量',
      duration: '版本时长',
      status: '项目/版本状态',
      createVersion: '新建项目',
      unlock: {
        label: '解锁该项目的录屏工程文件',
        describe:
          '若调整了Unity对应项目内的游戏内容，项目内历史版本内容可能无法正常展示。',
      },
      copyproduct: '复制项目',
      delete: {
        label: '删除该项目',
        describe:
          '删除录屏项目，项目内工程文件及版本会一并删除，但不影响该项目已导出的视频作品。<br/>若此项目正在同步工程文件或导出视频，删除操作可能失败。<br/>删除后将无法恢复，确定删除吗？',
      },
      version: {
        delete: '删除该版本',
        describe: '删除后将无法恢复，确定删除吗？',
      },
    },
    createproject: '新建录屏项目',
    editproject: '编辑录屏项目详情',
    basic: {
      information: '基本信息',
      productName: '推广产品',
      productNameTips: '请输入项目名称',
      projectName: '项目名称',
      projectNameTips: '请输入项目名称',
      placeholder: '请输入版本名称',
      keywords: '请搜索关键词进行选择',
      adaptation: '游戏适配方向',
      portrait: '竖屏',
      landscape: '横屏',
      describe: '为保证更好的的游戏录制效果，可选择希望导入的游戏适配方向。',
      noProject: '没有项目可选',
      paramsEmptyTips:
        '参数为空，您可以在“录屏参数管理”中新建参数，方便后续使用。',
      parameters: {
        title: '录屏参数',
        describe:
          '若项目已上传了录屏工程文件，新增的录屏参数不会马上在版本编辑页中应用。新增参数需要开发实现并同步更新录屏工程文件后，才会在版本编辑页中应用。',
      },
      existing: '从已有项目复制',
      default: '从参数字典复制',
      new: '新建参数',
      total: '共 {total} 条参数',
      table: {
        name: '名称',
        achieve: '参数状态',
        describe: '未在Unity中定义的参数不会在录屏编辑器页面展示',
        operation: '操作',
        delete: '未在Unity中定义的参数被删除后不可恢复，确定删除吗?',
        note: '说明',
        selected: '已选',
        content: '选项值',
        defaults: '默认值',
        hidetips: '点击可隐藏',
        showtips: '点击可显示',
      },
    },
    projectDrop: {
      recordPackage: '录屏工程文件',
      packageName: '文件名称',
      packageStatus: '状态',
      packageStatus1: '已锁定',
      packageStatus2: '未锁定',
      packageUpdateTime: '更新时间',
      packageSize: '大小',
    },
    cover: {
      title: '录屏参数重复',
      info: '选择的参数与已有参数重名，无法添加到项目中。<br />请返回编辑项目已有参数，或点击右下角跳过按钮，跳过现有冲突项，继续完成添加操作。',
      info1: '重复录屏参数',
      confirm: '跳过',
    },
    promotional: {
      create: '新增推广产品',
      producttype: '产品类型',
      platformtype: '平台类型',
      ios: {
        placeholder: '请输入苹果应用商店链接',
      },
      android: {
        placeholder: '请输入Google Play 或 安卓应用商店链接',
      },
      website: {
        placeholder: '请输入链接',
      },
    },
    existing: {
      select: '从已有项目选择',
      placeholder: '请搜索项目名称或ID进行选择',
      parameters: '项目参数',
      table: {
        name: '名称',
        note: '说明',
        type: '参数类型',
        content: '选项值',
        defaults: '默认值',
        emptyTips: '请先选择录屏项目',
      },
    },
    parameter: {
      select: '从参数字典选择',
      placeholder: '搜索参数名称',
    },
    select: {
      single: '单选项',
      multiple: '多选项',
      radio: '单选下拉',
      multi: '多选下拉',
      numvalue: '数值',
    },
    screen: {
      create: '新建录屏参数',
      describe:
        '参数编辑后，需要开发在插件中刷新查看项目信息，否则可能会编辑失败。',
      parametername: '参数名称',
      placeholder: '请输入参数名称',
      description: '请输入说明',
      edit: '编辑录屏参数',
      table: {
        sort: '排序',
        content: '内容',
        add: '添加选项',
        tips: '选项值至少需要 2 个',
        tips1: '设为默认值',
      },
      preview: '预览效果',
      option: '新选项',
    },
    operation: {
      guide: {
        label: '想要快速开始制作录屏项目？',
        describe: '试着按照下面的指引开始制作您的第一个录屏项目吧！',
        step1: {
          label: '新建录屏项目',
          describe: '创建录屏项目，增加希望调整的录屏参数。',
          confirm: '还未安装”Mindworks插件”？',
          view: '查看下载插件指南',
        },
        step2: {
          label: '在Unity中登录Mindworks插件，查看录屏项目信息。',
          describe:
            '在Unity中利用Mindworks插件，同步录屏工程文件到Playturbo平台。',
        },
        step3: {
          label: '在线录制、调整参数',
          describe:
            '在线完成游戏录制，通过调整参数设置，直接获取大量不同的视频。',
        },
        step4: {
          label: '完成编辑，导出视频',
          describe: '大功告成！',
        },
      },
    },
  },
}
